export const MEMBER_TAGS = [
  'Muhasebe',
  'Araç Kullanıcısı',
  'Aşçı',
  'İmam',
  'Müezzin',
  'Koordinatör',
  'Temizlik',
  'Güvenlik',
  'İkram',
  'Medya',
  'Program Sorumlusu',
  'Rehber',
] as const;

export type MemberTag = (typeof MEMBER_TAGS)[number];

export interface OrgMember {
  memberId: string;
  userId: string;
  email: string;
  fullName: string;
  phone?: string;
  role: string;
  status: string;
  isActive: boolean;
  eventAccess: 'all' | 'restricted';
  invitedVia?: string;
  invitedEventId?: string;
  allowedEventIds: string[];
  tags: string[];
  joinedAt: string;
}

export const DEFAULT_CHECKLIST_ITEMS = [
  'İçlik', 'Mont', 'Yağmurluk', 'Şemsiye', 'Termos', "Kur'an-ı Kerim",
  'Risale-i Nur (Sözler)', 'Risale-i Nur (Mektubat)', 'Seccade', 'Tesbih',
  'Powerbank', 'El Feneri', 'Yedek Çorap', 'Yedek İç Çamaşır', 'Yedek Ayakkabı',
  'Terlik', 'Bere / Şapka', 'Eldiven', 'Güneş Kremi', 'Diş Fırçası & Macun',
  'Sabun / Şampuan', 'Havlu', 'Peçete / Islak Mendil', 'Kişisel İlaçlar',
  'İlk Yardım Malzemesi', 'Su Şişesi', 'Atıştırmalık', 'Not Defteri & Kalem',
  'Nevresim / Uyku Tulumu', 'Çadır (varsa)', 'Uyku Matı', 'Battaniye', 'Yastık',
];

export const ORG_VS_PROGRAM_INFO = {
  organization: {
    title: 'Organizasyon',
    description:
      'Grubunuzun ana çatısıdır. Üyeler, davet linki, bağış/okuma linkleri, genel sohbet, checklist ve harcamalar organizasyon düzeyinde yönetilir.',
  },
  program: {
    title: 'Program (Etkinlik)',
    description:
      'Organizasyon içindeki belirli bir maneviyat programıdır. Tarih, konum, konaklama ve saat saat program akışı burada yer alır.',
  },
};
